import { z } from 'zod';
import { isoDateTimeSchema } from './common.js';

export const timelineEventTypeSchema = z.enum([
  'note',
  'stage_started',
  'stage_completed',
  'stage_blocked',
  'milestone',
  'issue',
  'delivery',
  'inspection',
  'photo',
  'daily_log',
]);
export type TimelineEventType = z.infer<typeof timelineEventTypeSchema>;

export const timelineEventSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  stageId: z.string().nullable(),
  eventType: timelineEventTypeSchema,
  title: z.string(),
  description: z.string().nullable(),
  eventAt: z.string(),
  createdBy: z.string(),
  createdByName: z.string(),
  createdAt: z.string(),
  photoCount: z.number().int().min(0),
});
export type TimelineEvent = z.infer<typeof timelineEventSchema>;

export const createTimelineEventRequestSchema = z.object({
  stageId: z.string().optional(),
  eventType: timelineEventTypeSchema.default('note'),
  title: z.string().trim().min(1).max(160),
  description: z.string().trim().max(4000).optional(),
  eventAt: isoDateTimeSchema.optional(),
  photoIds: z.array(z.string()).max(20).optional(),
});
export type CreateTimelineEventRequest = z.infer<typeof createTimelineEventRequestSchema>;
